import { FC, ReactElement } from 'react'

import { isChristmas } from '../../helpers/date'

import './ValkLogo.scss'

interface ValkLogoProps {
    className?: string;
}

const ValkLogo: FC<ValkLogoProps> = ({ className = '' }): ReactElement => {
    const src = isChristmas
        ? '/images/valk-christmas-logo.svg'
        : '/images/valk-logo.svg'

    return (
        <div className={`valk-logo ${className}`}>
            <img
                alt="valk-logo"
                src={src}
                className="valk-logo__image"
            />
        </div>
    )
}

export default ValkLogo
